import React from 'react'
import { StyleSheet, TouchableOpacity, View } from 'react-native'
import { BtPlainText } from '@linqpal/components/src/ui'
import { BackIcon, ModalCloseIcon } from '../../assets/icons'

interface IProps {
  title?: string | JSX.Element
  titleStyle?: any
  onBack?: () => void
  onClose?: () => void
}

export const BtModalHeader: React.FC<IProps> = ({
  title,
  titleStyle,
  onBack,
  onClose,
}) => {
  return (
    <View style={styles.container}>
      {!!onBack && (
        <TouchableOpacity onPress={onBack}>
          <BackIcon width={40} height={40} />
        </TouchableOpacity>
      )}

      {typeof title === 'string' ? (
        <BtPlainText style={[styles.title, titleStyle]}>{title}</BtPlainText>
      ) : (
        title
      )}

      <TouchableOpacity
        onPress={onClose}
        style={!title ? { marginLeft: 'auto' } : {}}
      >
        <ModalCloseIcon width={40} height={40} />
      </TouchableOpacity>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: 32,
    marginBottom: 0,
    gap: 10,
  },
  title: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: '700',
    fontSize: 24,
    lineHeight: 34,
    letterSpacing: -0.5,
    color: '#001929',
    textAlign: 'left',
  },
})
